<form novalidate (ngSubmit)="onSubmit()" (keyup.enter)="onSubmit()" [formGroup]="form">
  <ion-list>
    <div class="ion-padding-start ion-padding-top">
      <h4>Reset your password</h4>
    </div>
    <ion-item lines="inset">
      <ion-label color="medium" position="floating">New password</ion-label>
      <ion-input type="password" formControlName="password" autocomplete="new-password"></ion-input>
    </ion-item>
    @if (submitted && form.get('password').hasError('required')) {
      <ion-text color="danger" class="error-message">
        <span padding>Please enter a password</span>
      </ion-text>
    }
    @if (submitted && form.get('password').hasError('minlength')) {
      <ion-text color="danger" class="error-message">
        <span padding>Password must be longer than 8 characters</span>
      </ion-text>
    }
    @if (submitted && form.get('password').hasError('pattern')) {
      <ion-text color="danger" class="error-message">
        <span padding>Please must contain a number and a special character</span>
      </ion-text>
    }
    <ion-item lines="inset">
      <ion-label color="medium" position="floating">Confirm new password</ion-label>
      <ion-input type="password" formControlName="confirmPassword" autocomplete="new-password"></ion-input>
    </ion-item>
    @if (submitted && form.hasError('notSame')) {
      <ion-text color="danger" class="error-message">
        <span padding>Please make sure both passwords are the same</span>
      </ion-text>
    }
    @if (submitted && form.get('confirmPassword').hasError('required')) {
      <ion-text
        color="danger"
        class="error-message"
        >
        <span padding>Please confirm your new password</span>
      </ion-text>
    }
    @if (submitted && form.get('confirmPassword').hasError('minlength')) {
      <ion-text
        color="danger"
        class="error-message"
        >
        <span padding>Please enter a stronger password</span>
      </ion-text>
    }
  </ion-list>
  <ion-button
    type="submit"
    color="primary"
    expand="block"
    class="ion-margin-top ion-margin-start ion-margin-end"
  >
    Submit
  </ion-button>
</form>
